import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, Catalogue } from "../base";
import { IEnumApi } from "../enum-api";
import { ContractInsurance } from "./contract-insurance";
import { ExtraInfomation } from "./extra-infomation";

export const Avatar = types.model({
  name: types.maybeNull(types.string),
  originName: types.maybeNull(types.string),
});

export const Employee = types
  .compose(
    Base,
    types.model({
      orderNumber: types.maybeNull(types.number),
      fullName: types.maybeNull(types.string),
      code: types.maybeNull(types.string),
      departmentTypeId: types.maybeNull(types.string),
      position: types.maybeNull(types.string),
      level: types.maybeNull(types.string),
      qualification: types.maybeNull(types.string),
      gender: types.maybeNull(types.number),
      branch: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
      avatar: types.maybeNull(Avatar),
      hsYear: types.maybeNull(types.number),
      age: types.maybeNull(types.number),
      avatarId: types.maybeNull(types.string),
      information: types.maybeNull(ExtraInfomation),
      contractInsurance: types.maybeNull(ContractInsurance),
      departmentType: types.maybeNull(Catalogue),
      genderModel: types.maybeNull(types.frozen<IEnumApi>()),
    })
  )
  .actions(withSetPropAction);
export interface IEmployee extends Instance<typeof Employee> {}
export interface IEmployeeProperties extends SnapshotIn<typeof Employee> {}

export const EmployeeDetail = types.compose(Employee, types.model({}));
export interface IEmployeeDetail extends Instance<typeof EmployeeDetail> {}
export interface IEmployeeDetailProperties
  extends SnapshotIn<typeof EmployeeDetail> {}

export interface IAddEmployee
  extends Pick<
    IEmployeeProperties,
    | "fullName"
    | "code"
    | "departmentTypeId"
    | "position"
    | "level"
    | "qualification"
    | "gender"
    | "branch"
    | "note"
  > {}

export interface IUpdateEmployee
  extends Pick<
    IEmployeeDetailProperties,
    | "fullName"
    | "code"
    | "departmentTypeId"
    | "position"
    | "level"
    | "qualification"
    | "gender"
    | "branch"
    | "note"
    | "id"
  > {}
